import models from 'redux/models/rest'
import view from 'redux/view/rest'


export default {
  models,
  view,
}
